import { getUniqueId } from '@ankr.com/utils/getUniqueId';

export const authCacheTags = {
  account: `account-${getUniqueId()}`,
  disconnect: `disconnect-${getUniqueId()}`,
};
